import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const UserProfileViewTopBar = memo(() => {
	return <BaseTopBar showAIButton={false} />
})
UserProfileViewTopBar.displayName = "UserProfileViewTopBar"
